import React, { useState } from 'react';
import api from '../api';
import './PublicUploadPage.css';

function PublicUploadPage() {
  const [form, setForm] = useState({
    title: '',
    description: '',
    uploaderName: '',
    mobileNumber: '',
    adharCardNumber: '',
  });
  const [image, setImage] = useState(null);
  const [adharImage, setAdharImage] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submitWithFallback = async (data) => {
    try {
      return await api.post('/api/public-news/submit', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    } catch (err) {
      if (err && err.response && err.response.status === 404) {
        return await api.post('/api/news/public/submit', data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      throw err;
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!form.title || !form.description || !form.uploaderName || !form.mobileNumber || !form.adharCardNumber || !image || !adharImage) {
      setError('सभी फील्ड भरना अनिवार्य है।');
      return;
    }

    try {
      setSubmitting(true);
      const data = new FormData();
      data.append('title', form.title);
      data.append('description', form.description);
      data.append('uploaderName', form.uploaderName);
      data.append('mobileNumber', form.mobileNumber);
      data.append('adharCardNumber', form.adharCardNumber);
      data.append('image', image);
      data.append('adharImage', adharImage);

      const res = await submitWithFallback(data);

      if (res && res.data && res.data.success) {
        setMessage('आपकी खबर सफलतापूर्वक भेज दी गई है। अप्रूवल के बाद यह पब्लिश होगी। भेजी गई खबर के जिम्मेदार आप स्वयं होंगे। Thank you for your contribution! RR News TV Team');
        setForm({
          title: '',
          description: '',
          uploaderName: '',
          mobileNumber: '',
          adharCardNumber: '',
        });
        setImage(null);
        setAdharImage(null);
      } else {
        setError((res && res.data && res.data.message) || 'सबमिशन फेल हो गया।');
      }
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || err.message || 'सबमिशन फेल हो गया।');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="public-upload-page">
      <div className="container">
        <div className="public-upload-card">
          <h1>Public Upload</h1>
          <p className="public-upload-subtitle">कोई भी अपनी खबर भेज सकता है। सभी फील्ड अनिवार्य हैं।</p>

          {message && <div className="public-success">{message}</div>}
          {error && <div className="public-error">{error}</div>}

          <form onSubmit={onSubmit} className="public-upload-form">
            <label>
              Title of News *
              <input type="text" name="title" value={form.title} onChange={onChange} required />
            </label>

            <label>
              Description *
              <textarea name="description" value={form.description} onChange={onChange} rows={5} required />
            </label>

            <label>
              Name of Uploader *
              <input type="text" name="uploaderName" value={form.uploaderName} onChange={onChange} required />
            </label>

            <label>
              Mobile Number *
              <input type="tel" name="mobileNumber" value={form.mobileNumber} onChange={onChange} required />
            </label>

            <label>
              Adhar Card Number *
              <input type="text" name="adharCardNumber" value={form.adharCardNumber} onChange={onChange} required />
            </label>

            <label>
              News Image *
              <input
                type="file"
                accept="image/*"
                required
                onChange={(e) => setImage(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
              />
            </label>

            <label>
              Adhar Image *
              <input
                type="file"
                accept="image/*"
                required
                onChange={(e) => setAdharImage(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
              />
            </label>

            <button type="submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit Public News'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PublicUploadPage;
